import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Constant } from '../../environments/constants';
import { Utils } from '../../utils/utils';
import { DataService } from './context/data.service';
import { AppMonitoringService } from '../services/util/app-monitoring.service';
import * as fromModel from '../services/models/';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {

  constructor(private http: HttpClient,
              // private dataService:DataService,
              private appMonitoringService: AppMonitoringService) { }

  getAccountsAPI(accountNumbers) {
    let url =    Constant.uri.cosmosaccountsearchapi+'?'+ Constant.searchQuery.accountSearchIn+"&$filter=((search.in(id,'" + accountNumbers +"')))";
    return this.http.get(encodeURI(url), Utils.getHttpOptions());
  }  

  // getAccounts(accountNumbers) {
  //   if(!this.dataService.appData.Accounts || this.dataService.appData.Accounts['Error']) {
  //     this.getAccountsAPI(accountNumbers).subscribe(result=>{
  //         this.dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS,"AccountsService-getAccounts", result);
  //     }, err=>{
  //       this.dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS,"AccountsService-getAccounts", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
  //       console.log("Error getting Account Details: " + JSON.stringify(err));      
  //       this.appMonitoringService.traceMsg("Error getting Account Details: ", JSON.stringify(err) , 'Error');
  //     });
  //   }
  // }

  getAccounts(accountNumbers, dataService: DataService) {
    if(!dataService.appData.Accounts || dataService.appData.Accounts['Error']) {
      this.getAccountsAPI(accountNumbers).subscribe(result=>{
          dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS,"AccountsService-getAccounts", result);
      }, err=>{
        dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS,"AccountsService-getAccounts", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
        console.log("Error getting Account Details: " + JSON.stringify(err));      
        this.appMonitoringService.traceMsg("Error getting Account Details: ", JSON.stringify(err) , 'Error');
      });
    }
  }

}